import React, { useState, useEffect } from 'react';
import { Breadcrumb, Button, Card, Table, Spin } from 'antd';
import {
  ArrowLeftOutlined,
  PlusOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { getApphomeConfig } from './ApphomeActions';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppHomeCreateAndUpdateButton from './ManageActions/AppHomeCreateAndUpdateButton';
import CustomizeData from './MangeContent/CustomizeData';
import './ApphomeFullview.css';
import qs from 'query-string';
import { deleteButtonAction } from './ApphomeActions';

const ApphomeFullView = (props) => {
  const isAdmin = useSelector((state) => state.common_reducer.isAdmin);
  const [showNotAnAdminError, setShowNotAnAdminError] = useState(false);
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;
  const dispatch = useDispatch();
  const { view, id } = qs.parse(props.location.search);
  const apphome = useSelector((state) => state.apphome.apphome);
  const isPersonalApphome = apphome.isWorkspaceApphome ? false : true;
  const pageInfo =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === (apphome && apphome.pageView));
  const pageViewType = pageInfo && pageInfo.pageViewType;
  const [buttonsList, setButtonsList] = useState([]);
  const [backData, setBackData] = useState({ name: '', link: '' });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (props.isAdminApphome && !isAdmin) {
      setShowNotAnAdminError(true);
    } else {
      setShowNotAnAdminError(false);
    }
  }, [isAdmin]);
  useEffect(() => {
    setLoading(true);
    (async () => {
      await dispatch(
        getApphomeConfig(props.match.params.wId, isPersonalApphome, true)
      );
      setLoading(false);
    })();
  }, []);
  useEffect(() => {
    const findPage =
      apphome &&
      apphome.pages &&
      apphome.pages.find((page) => page._id === apphome.pageView);
    if (findPage) {
      setButtonsList(findPage && findPage.actions);
    }
  }, [apphome]);
  useEffect(() => {
    backHistoryData();
  }, [view]);
  const handleDelete = async (recordId) => {
    await dispatch(
      deleteButtonAction(
        props.match.params.wId,
        apphome && apphome._id,
        apphome && apphome.pageView,
        recordId
      )
    );
  };
  const pagination = {
    pageSize: 7, // how many rows to show per page
    total: buttonsList.length, // total number of rows
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // custom text for total and range
  };
  // /:wId/settings/personalapphome/customize

  const columns = [
    {
      title: 'Button Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <a>
          {
            <Link
              to={
                isPersonalApphome
                  ? `/${props.match.params.wId}/settings/personalapphome/customize?view=updateAction&id=${record._id}`
                  : `/${props.match.params.wId}/slackApp/apphome?view=updateAction&id=${record._id}`
              }
            >
              {text}
            </Link>
          }
        </a>
      ),
    },
    {
      title: 'Purpose',
      dataIndex: 'purpose',
      key: 'purpose',
    },
    {
      title: 'Creator',
      dataIndex: 'creator',
      key: 'creator',
      render: (_, record) => (
        <div>
          {record.createdByTroopr
            ? 'Troopr'
            : record.createdBy && record.createdBy._id
            ? record.createdBy.displayName || record.createdBy.name
            : ''}
        </div>
      ),
    },

    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <a>
          <Link
            to={
              isPersonalApphome
                ? `/${props.match.params.wId}/settings/personalapphome/customize?view=updateAction&id=${record._id}`
                : `/${props.match.params.wId}/slackApp/apphome?view=updateAction&id=${record._id}`
            }
          >
            Update
          </Link>
        </a>
      ),
    },
    {
      key: 'action',
      render: (_, record) => (
        <div style={{ cursor: 'pointer' }}>
          <DeleteOutlined onClick={() => handleDelete(record._id)} />
        </div>
      ),
    },
  ];

  const getBreadCrumbs = () => {
    return (
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link
            to={
              isPersonalApphome
                ? `/${props.match.params.wId}/settings/personalapphome`
                : `/${props.match.params.wId}/slackApp?view=appHome`
            }
          >
            Apphome
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link
            to={
              isPersonalApphome
                ? `/${props.match.params.wId}/settings/personalapphome`
                : `/${props.match.params.wId}/slackApp?view=appHome`
            }
          >
            Issue Page
          </Link>
        </Breadcrumb.Item>

        {view === 'createAction' || view === 'updateAction' ? (
          <Breadcrumb.Item>
            <Link
              to={
                isPersonalApphome
                  ? `/${props.match.params.wId}/settings/personalapphome/customize?pageView=${pageViewType}&view=buttonList`
                  : `/${props.match.params.wId}/slackApp/apphome?pageView=${pageViewType}&view=buttonList`
              }
            >
              Customize button
            </Link>
          </Breadcrumb.Item>
        ) : (
          ''
        )}
        {view === 'customizeData' && (
          <>
            <Breadcrumb.Item>Customize data</Breadcrumb.Item>
          </>
        )}
        {view === 'buttonList' && (
          <Breadcrumb.Item>Customize Buttons</Breadcrumb.Item>
        )}
        {view === 'createAction' && (
          <Breadcrumb.Item>Create new button</Breadcrumb.Item>
        )}
        {view === 'updateAction' && (
          <Breadcrumb.Item>Update button</Breadcrumb.Item>
        )}
      </Breadcrumb>
    );
  };

  const backHistoryData = () => {
    let name, link;

    if (view === 'buttonList') {
      name = 'Customize buttons';
      if (isPersonalApphome) {
        link = `/${props.match.params.wId}/settings/personalapphome`;
      } else {
        link = `/${props.match.params.wId}/slackApp?view=appHome`;
      }
    } else if (view === 'createAction') {
      name = 'Create new button';
      link = isPersonalApphome
        ? `/${props.match.params.wId}/settings/personalapphome/customize?view=buttonList`
        : `/${props.match.params.wId}/slackApp/apphome?view=buttonList`;
    } else if (view === 'updateAction') {
      name = 'Update button';
      link = isPersonalApphome
        ? `/${props.match.params.wId}/settings/personalapphome/customize?view=buttonList`
        : `/${props.match.params.wId}/slackApp/apphome?view=buttonList`;
    } else if (view === 'customizeData') {
      name = 'Customize data';
      if (isPersonalApphome) {
        link = `/${props.match.params.wId}/settings/personalapphome`;
      } else {
        link = `/${props.match.params.wId}/slackApp?view=appHome`;
      }
    }

    setBackData({ name, link });
  };

  return (
    <>
      {loading ? (
        <Spin
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      ) : showNotAnAdminError ? (
        <h1
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {' '}
          Admin access required
        </h1>
      ) : (
        <div>
          <div
            style={{
              height: '102px',
              background: `${isDarkTheme ? '' : '#fff'}`,
              padding: '16px 24px 24px 24px',
            }}
          >
            {getBreadCrumbs()}
            <div
              style={{
                paddingTop: '14px',
                fontSize: '20px',
                fontWeight: '500',
                lineHeight: '28px',
              }}
            >
              <Link to={backData.link}>
                {' '}
                <ArrowLeftOutlined /> &nbsp;{' '}
              </Link>
              {backData && backData.name}
            </div>
          </div>
          {view === 'buttonList' && (
            <div style={{ marginTop: '24px', padding: '0px 24px' }}>
              <Card
                title={
                  <Button type='primary'>
                    <Link
                      to={
                        isPersonalApphome
                          ? `/${props.match.params.wId}/settings/personalapphome/customize?view=createAction&pageViewType=${pageViewType}`
                          : `/${props.match.params.wId}/slackApp/apphome?view=createAction&pageViewType=${pageViewType}`
                      }
                    >
                      <PlusOutlined /> &nbsp; Add Button
                    </Link>
                  </Button>
                }
              >
                <Table
                  pagination={pagination}
                  columns={columns}
                  dataSource={buttonsList}
                />
              </Card>
            </div>
          )}
          {(view === 'createAction' || view === 'updateAction') && (
            <AppHomeCreateAndUpdateButton
              apphome={apphome}
              pageViewType={pageViewType}
              view={view}
              id={id}
              isPersonalApphome={isPersonalApphome}
              buttonsList={buttonsList}
            />
          )}
          {view === 'customizeData' && <CustomizeData />}
        </div>
      )}
    </>
  );
};

export default withRouter(ApphomeFullView);
